module.exports = __webpack_public_path__ + "static/media/rivatrans.22fb973e.jpg";